/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { ModbusVariableAddress } from './models';
import { VariableType } from './models';
import { VariableMeta } from './models';
import { ReadWriteRights } from '@iotize/tap/service/impl/bundle';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class VariableService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get variable address
   *
   * LWM2M path: /1029/{variableId}/0
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getVariableAddress(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getVariableAddressCall(variableId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/0
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getVariableAddressCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getVariableAddress };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write variable address
   *
   * LWM2M path: /1029/{variableId}/0
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param address input
   * @return
   */
  putVariableAddress(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * New address of the variable
     */
    address: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putVariableAddressCall(variableId, address),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/0
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param address input
   * @return call options
   */
  putVariableAddressCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * New address of the variable
     */
    address: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putVariableAddress };

    callOptions.body = address;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write modbus variable address
   *
   * LWM2M path: /1029/{variableId}/0
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param address input
   * @return
   */
  putModbusVariableAddress(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * New address of the variable
     */
    address: ModbusVariableAddress,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putModbusVariableAddressCall(variableId, address),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/0
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param address input
   * @return call options
   */
  putModbusVariableAddressCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * New address of the variable
     */
    address: ModbusVariableAddress,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putModbusVariableAddress };

    callOptions.body = address;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get data type for variable
   *
   * LWM2M path: /1029/{variableId}/1
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getType(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<VariableType>> {
    return this.serviceCallRunner.execute(this.getTypeCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/1
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getTypeCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getType };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get data type for variable
   *
   * LWM2M path: /1029/{variableId}/1
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param type input
   * @return
   */
  putType(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * variable type
     */
    type: VariableType,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putTypeCall(variableId, type));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/1
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param type input
   * @return call options
   */
  putTypeCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * variable type
     */
    type: VariableType,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putType };

    callOptions.body = type;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get variable meta
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @return
   */
  getRawMeta(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.getRawMetaCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @return call options
   */
  getRawMetaCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getRawMeta };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write variable meta
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @param meta input
   * @return
   */
  putRawMeta(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * Variable meta
     */
    meta: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putRawMetaCall(variableId, meta),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @param meta input
   * @return call options
   */
  putRawMetaCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * Variable meta
     */
    meta: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putRawMeta };

    callOptions.body = meta;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get variable meta
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @return
   */
  getMeta(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<VariableMeta>> {
    return this.serviceCallRunner.execute(this.getMetaCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @return call options
   */
  getMetaCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getMeta };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write variable meta
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @param meta input
   * @return
   */
  putMeta(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * Variable meta
     */
    meta: VariableMeta,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putMetaCall(variableId, meta));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/8
   *
   * @tapVersion(">=1.73")
   * @param variableId input
   * @param meta input
   * @return call options
   */
  putMetaCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * Variable meta
     */
    meta: VariableMeta,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMeta };

    callOptions.body = meta;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get variable unit
   *
   * LWM2M path: /1029/{variableId}/9
   *
   * @deprecated
   * @tapVersion(">=1.60")
   * @param variableId input
   * @return
   */
  getUnit(
    /*
     * Variable id
     */
    variableId: number,
  ): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getUnitCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/9
   *
   * @deprecated
   * @tapVersion(">=1.60")
   * @param variableId input
   * @return call options
   */
  getUnitCall(
    /*
     * Variable id
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getUnit };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write variable unit
   *
   * LWM2M path: /1029/{variableId}/9
   *
   * @deprecated
   * @tapVersion(">=1.60")
   * @param variableId input
   * @param address input
   * @return
   */
  putUnit(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * Variable unit
     */
    address: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putUnitCall(variableId, address),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/9
   *
   * @deprecated
   * @tapVersion(">=1.60")
   * @param variableId input
   * @param address input
   * @return call options
   */
  putUnitCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * Variable unit
     */
    address: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putUnit };

    callOptions.body = address;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get variable array size
   *
   * LWM2M path: /1029/{variableId}/2
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getNumberOfElements(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(
      this.getNumberOfElementsCall(variableId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/2
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getNumberOfElementsCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getNumberOfElements };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write variable array size
   *
   * LWM2M path: /1029/{variableId}/2
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return
   */
  putNumberOfElements(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * New number of element for this variable
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putNumberOfElementsCall(variableId, value),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/2
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return call options
   */
  putNumberOfElementsCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     * New number of element for this variable
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNumberOfElements };

    callOptions.body = value;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get access rights for the variable
   *
   * LWM2M path: /1029/{variableId}/3
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getCurrentAccess(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<ReadWriteRights>> {
    return this.serviceCallRunner.execute(
      this.getCurrentAccessCall(variableId),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/3
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getCurrentAccessCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getCurrentAccess };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get values of all variable for the current profile
   *
   * LWM2M path: /1029//4
   *
   * @tapVersion(">=1.0")
   * @return
   */
  readProfile(): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.readProfileCall());
  }

  /**
   *
   *
   * LWM2M path: /1029//4
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  readProfileCall(): ServiceCallType {
    const callOptions = { ...this.resources.readProfile };

    return callOptions;
  }

  /**
   * Get variable value
   *
   * LWM2M path: /1029/{variableId}/4
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getValue(
    /*
     * ID of the variable
     */
    variableId: number,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.getValueCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/4
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getValueCall(
    /*
     * ID of the variable
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getValue };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Set variable value
   *
   * LWM2M path: /1029/{variableId}/5
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return
   */
  setValue(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.setValueCall(variableId, value));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/5
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return call options
   */
  setValueCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.setValue };

    callOptions.body = value;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Set variable value
   *
   * LWM2M path: /1029/{variableId}/4
   *
   * @deprecated
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return
   */
  putValue(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     *
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putValueCall(variableId, value));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/4
   *
   * @deprecated
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return call options
   */
  putValueCall(
    /*
     * ID of the variable
     */
    variableId: number,

    /*
     *
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putValue };

    callOptions.body = value;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get variable bundle id
   *
   * LWM2M path: /1029/{variableId}/6
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getBundleId(
    /*
     *
     */
    variableId: number,
  ): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getBundleIdCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/6
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getBundleIdCall(
    /*
     *
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getBundleId };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Write variable bundle id
   *
   * LWM2M path: /1029/{variableId}/6
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return
   */
  putBundleId(
    /*
     *
     */
    variableId: number,

    /*
     *
     */
    value: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putBundleIdCall(variableId, value),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/6
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param value input
   * @return call options
   */
  putBundleIdCall(
    /*
     *
     */
    variableId: number,

    /*
     *
     */
    value: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBundleId };

    callOptions.body = value;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Get variable bundle values (formated as a TLV)
   *
   * LWM2M path: /1029/{variableId}/7
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return
   */
  getBundleValues(
    /*
     *
     */
    variableId: number,
  ): Promise<TapResponse<Uint8Array>> {
    return this.serviceCallRunner.execute(this.getBundleValuesCall(variableId));
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/7
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @return call options
   */
  getBundleValuesCall(
    /*
     *
     */
    variableId: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.getBundleValues };

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }

  /**
   * Create a variable
   *
   * LWM2M path: /1029/{variableId}/65535
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param extraSize input
   * @return
   */
  create(
    /*
     *
     */
    variableId: number,

    /*
     * extra data size in bytes
     */
    extraSize: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.createCall(variableId, extraSize),
    );
  }

  /**
   *
   *
   * LWM2M path: /1029/{variableId}/65535
   *
   * @tapVersion(">=1.0")
   * @param variableId input
   * @param extraSize input
   * @return call options
   */
  createCall(
    /*
     *
     */
    variableId: number,

    /*
     * extra data size in bytes
     */
    extraSize: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.create };

    callOptions.body = extraSize;

    callOptions.pathParameters = {
      variableId: variableId,
    };

    return callOptions;
  }
}
